export default "__VITE_ASSET__CkPkduiH__"